import { SvgIconProps } from "@mui/material";
import React from "react";

declare module "@mui/material/SvgIcon" {
  interface SvgIconPropsColorOverrides {
    primaryContrastText: true;
  }
}

interface IconWrapperProps extends SvgIconProps {
  icon: React.ReactElement;
  fontSize?: SvgIconProps["fontSize"];
  color?: SvgIconProps["color"];
}

const Icon: React.FC<IconWrapperProps> = ({
  icon,
  fontSize = "small",
  color = "primary",
  ...props
}) => {
  return React.cloneElement(icon as React.ReactElement<SvgIconProps>, {
    fontSize,
    color,
    ...props,
  });
};

export default Icon;
